var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "soc-smart-guide-float" }, [
        _c("div", { staticClass: "float-body" }, [
          _c("div", { staticClass: "float-title" }, [
            _vm._v("智能引导 · " + _vm._s(_vm.stepTitle))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "float-hint" }, [
            _vm._v(_vm._s(_vm.instruction))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "float-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.goPage }
                },
                [_vm._v("去此页")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", loading: _vm.loading },
                  on: { click: _vm.check }
                },
                [_vm._v("检查完成")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "text" },
                  on: { click: _vm.openAssistant }
                },
                [_vm._v("助手")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.reason
            ? _c(
                "p",
                { staticClass: "float-reason", class: { ok: _vm.passed } },
                [_vm._v(_vm._s(_vm.reason))]
              )
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3c7ca2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3c7ca2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeoKnowledge/SocSmartGuideFloat.vue
// module id = null
// module chunks = 